export default "__VITE_ASSET__DRMQ4ubI__"